import { inject, Injectable } from '@angular/core';
import { FsApiService } from './fs-api.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class FsAuthService {
  private api = inject(FsApiService);
  // private authServices = inject(AuthService);

  getUsersMe() {
    // const authToken = this.authServices.userInfo.authToken;

    return this.api.get('/users/me', {
      // headers: { Authorization: `Bearer ${authToken}` },
    });
  }

  // getPublicInfo() {
  //   return this.api.get('/public/info', {
  //     headers: { 'No-Auth': 'true' }, // este endpoint no requiere token
  //   });
  // }
}
